import lazy from './lazy.js'
import equalizeInlineFilters from './equalize-inline-filters.js'
import scrollReveal from './scroll-reveal.js'

const htmxEvents = {
    init() {
        if (typeof htmx !== 'undefined') {
            // Add the HTMX target to GET request URLs so full-page and fragment responses
            // use different browser and CDN cache keys and cannot replace each other.
            // See https://htmx.org/docs/#caching.
            htmx.config.getCacheBusterParam = true;
            // Request a full document on history cache misses because this site uses the
            // HX-Request header to return fragments.
            // See https://htmx.org/docs/#history-cache.
            htmx.config.historyRestoreAsHxRequest = false;

            this.setupScrollBehavior();
            this.setupLoadingStates();
        }
    },

    setupScrollBehavior() {
        htmx.on('htmx:afterSwap', function(event) {
            // Try to find sprig container related to this specific event
            let container = null;

            // First, check if the target itself is the sprig container
            if (event.detail.target && event.detail.target.id === 'sprig-container') {
                container = event.detail.target;
            }

            if (event.detail?.target?.querySelector('#sprig-container')) {
                container = event.detail.target.querySelector('#sprig-container');
            }

            if (!container) return;

            const top = container.offsetTop - 120;

            setTimeout(() => {
                window.scrollTo({top: (top || 0), behavior: 'smooth'});
            }, 20);
        });
    },

    setupLoadingStates() {
        htmx.on('htmx:afterSwap', function(event) {
            const swappedElement = event.detail.elt ?? event.detail.target;

            if (!swappedElement) return;

            // Initialize reveals before the lazy-loading MutationObserver handles swapped images.
            scrollReveal.refresh(swappedElement);
        });

        htmx.on('htmx:beforeRequest', function(event) {
            event.detail.target.classList.add('is-loading');
        });

        htmx.on('htmx:afterRequest', function(event) {
            event.detail.target.classList.remove('is-loading');
        });

        htmx.on('htmx:afterSettle', function(event) {
            const settledElement = event.detail.elt;

            equalizeInlineFilters.refresh(settledElement);
            scrollReveal.refresh(settledElement);
            lazy.refresh(settledElement);
        });
    }
};

export default htmxEvents;
